export default {
  create() {
    return {
      allow_to_see_tasks: true,
      allow_to_see_tasks_details: true, // NEU 27.03.2019
      allow_to_see_enddates: true,
      allow_to_see_commitment: true,
      allow_to_see_task_sessions: false,
      allow_to_see_recorded_sessions: false,
      allow_to_edit_tasks: true, //  = create, update, delete
      allow_to_edit_tasks_details: true, // NEU 27.03.2019
      allow_to_edit_commitments: true,
      allow_to_see_daily_commitments: true, // NEU 13.04.2019
    };
  },
  fields: {
    allow_to_see_tasks: {
      validate_bolt_type: 'Boolean'
    },
    allow_to_see_tasks_details: { // NEU 27.03.2019
      validate_bolt_type: 'Boolean'
    },
    allow_to_see_enddates: {
      validate_bolt_type: 'Boolean'
    },
    allow_to_see_commitment: {
      validate_bolt_type: 'Boolean'
    },
    allow_to_see_task_sessions: {
      validate_bolt_type: 'Boolean'
    },
    allow_to_see_recorded_sessions: {
      validate_bolt_type: 'Boolean'
    },
    allow_to_edit_tasks: {
      validate_bolt_type: 'Boolean'
    },
    allow_to_edit_tasks_details: { // NEU 27.03.2019
      validate_bolt_type: 'Boolean'
    },
    allow_to_edit_commitments: {
      validate_bolt_type: 'Boolean'
    },
    allow_to_see_daily_commitments: {
      validate_bolt_type: 'Boolean'
    },
  }
};
